"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import MapsHomeWorkOutlinedIcon from "@mui/icons-material/MapsHomeWorkOutlined";
import AddTaskOutlinedIcon from "@mui/icons-material/AddTaskOutlined";
import LeaderboardOutlinedIcon from "@mui/icons-material/LeaderboardOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import RecordVoiceOverOutlinedIcon from "@mui/icons-material/RecordVoiceOverOutlined";
import ChairOutlinedIcon from "@mui/icons-material/ChairOutlined";
import CurrencyRupeeOutlinedIcon from "@mui/icons-material/CurrencyRupeeOutlined";
import { HexBadge, LoadedTrolley } from "../../[slug]/_components/_icons/CustomIcons";
const shouldRenderHorizontalLine = (data, index, digitalProfile) => {
  for (let j = index + 1; j < data.length; j++) {
    const nextItem = data[j];
    if (nextItem.component === "lineItem") {
      const nextValue = nextItem?.content?.getValue?.(digitalProfile);
      if (nextValue === null) {
        continue;
      }
      return true;
    }
    if (nextItem.component === "title") {
      return false;
    }
    if (nextItem.component === "horizontalLine") {
      return true;
    }
  }
  return false;
};
const getListValue = value => Array.isArray(value) && value.length > 0 ? value.join(", ") : '--';
const getPlaceholderValue = (value, format) => {
  if (value == null || value === "") {
    return "--";
  }
  return format ? format(value) : value;
};
const getBooleanValue = (value, yesText, noText) => {
  switch (value) {
    case true:
    case "yes":
      return yesText;
    case false:
    case "no":
      return noText;
    default:
      return "--";
  }
};
function getProfileDetailsContentData(address) {
  return [{
    component: "title",
    content: "Basic Information"
  }, {
    component: "lineItem",
    content: {
      key: "area",
      label: "Area",
      icon: LocationOnOutlinedIcon,
      getValue: () => address?.area || "--"
    }
  }, {
    component: "horizontalLine"
  }, {
    component: "lineItem",
    content: {
      key: "businessAddress",
      label: "Business address",
      icon: StorefrontOutlinedIcon,
      getValue: () => address?.fullAddress || "--"
    }
  }, {
    component: "title",
    content: "Service Details"
  }, {
    component: "lineItem",
    content: {
      key: "moveInTimeline",
      label: "Move-in timeline",
      icon: ChairOutlinedIcon,
      getValue: dp => getPlaceholderValue(dp?.project_complete_timeline, v => `${v} days`),
      note: "*For a standard 2BHK"
    }
  }, {
    component: "horizontalLine"
  }, {
    component: "lineItem",
    content: {
      key: "serviceWarranty",
      label: "Service warranty",
      icon: HexBadge,
      getValue: dp => getPlaceholderValue(dp?.service_warranty, v => `${v} ${+v > 1 ? "years" : "year"}`)
    }
  }, {
    component: "horizontalLine"
  }, {
    component: "lineItem",
    content: {
      key: "labourCost",
      label: "Labour cost (Avg.)",
      icon: CurrencyRupeeOutlinedIcon,
      getValue: dp => dp?.avg_labour_cost || "--",
      note: "*For a standard 2BHK, Labour only"
    }
  }, {
    component: "horizontalLine"
  }, {
    component: "lineItem",
    content: {
      key: "provideMaterials",
      label: "Do you provide materials?",
      icon: LoadedTrolley,
      getValue: dp => getBooleanValue(dp?.material_provided, "Yes, I can provide materials", "No, labour only")
    }
  }, {
    component: "title",
    content: "Team & Credibility"
  }, {
    component: "lineItem",
    content: {
      key: "projectsExecuted",
      label: "Projects executed",
      icon: LeaderboardOutlinedIcon,
      getValue: dp => dp?.project_count != null ? `${dp.project_count}+` : "--"
    }
  }, {
    component: "horizontalLine"
  }, {
    component: "lineItem",
    content: {
      key: "teamSize",
      label: "Team size",
      icon: GroupOutlinedIcon,
      getValue: dp => getPlaceholderValue(dp?.team_size_v3 ?? dp?.team_size_v2 ?? dp?.team_size ?? dp?.teamSize)
    }
  }, {
    component: "horizontalLine"
  }, {
    component: "lineItem",
    content: {
      key: "fluentIn",
      label: "Fluent in",
      icon: RecordVoiceOverOutlinedIcon,
      getValue: dp => getListValue(dp?.languages)
    }
  }, {
    component: "title",
    content: "Work Profile"
  }, {
    component: "lineItem",
    content: {
      key: "experience",
      label: "Experience",
      icon: WorkspacePremiumOutlinedIcon,
      getValue: dp => getPlaceholderValue(dp?.work_experience_v2, v => `${v} yrs`)
    }
  }, {
    component: "horizontalLine"
  }, {
    component: "lineItem",
    content: {
      key: "propertyType",
      label: "Property type",
      icon: MapsHomeWorkOutlinedIcon,
      getValue: dp => getListValue(dp?.property_type_v2 ?? dp?.property_type)
    }
  }, {
    component: "horizontalLine"
  }, {
    component: "lineItem",
    content: {
      key: "addOnServicees",
      label: "Add-on services",
      icon: AddTaskOutlinedIcon,
      getValue: dp => getListValue(dp?.additional_services)
    }
  }];
}
export default function ProfileDetailsList(t0) {
  const $ = _c(8);
  const {
    digitalProfile,
    address,
    highlightKey: t1
  } = t0;
  const highlightKey = t1 === undefined ? null : t1;
  let t2;
  if ($[0] !== address) {
    t2 = getProfileDetailsContentData(address);
    $[0] = address;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const profileDetailsContentData = t2;
  let t3;
  if ($[2] !== digitalProfile || $[3] !== highlightKey || $[4] !== profileDetailsContentData) {
    t3 = profileDetailsContentData.map((item, index) => {
      const value = item?.content?.getValue?.(digitalProfile);
      if (value === null) {
        return null;
      }
      return <div key={index} data-detail-key={item.content?.key} className={`${item.component === "title" ? "mt-6 mb-2" : item.component === "lineItem" ? "py-3" : ""} ${highlightKey && item.content?.key === highlightKey ? "animate-dpHighlight" : ""}`}>{item.component === "title" && <h3 className="m3-title-large text-[--textPrimaryPrimary] sticky top-0  z-10">{item.content}</h3>}{item.component === "lineItem" && <div className="flex items-start gap-3"><item.content.icon className="!text-[--colorPrimaryPrimaryContainer] !text-[32px]" /><div className="flex flex-col"><p className="m3-body-large text-[--colorPrimaryPrimaryContainer] font-semibold">{item.content.label}</p><p className="m3-body-large text-[--textPrimaryPrimary]">{value}</p>{value !== "--" && item.content?.note && <p className="m3-label-small text-[--textDisabledDisabled]">{item.content?.note}</p>}</div></div>}{item.component === "horizontalLine" && shouldRenderHorizontalLine(profileDetailsContentData, index, digitalProfile) && <hr className="border-t border-[--colorSurfaceSurfaceOpacity8]" />}</div>;
    });
    $[2] = digitalProfile;
    $[3] = highlightKey;
    $[4] = profileDetailsContentData;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <>{t3}</>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}